import { render, staticRenderFns } from "./BannerMessage.vue?vue&type=template&id=0eac53b6&scoped=true&"
import script from "./BannerMessage.vue?vue&type=script&lang=js&"
export * from "./BannerMessage.vue?vue&type=script&lang=js&"
import style0 from "./BannerMessage.vue?vue&type=style&index=0&id=0eac53b6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0eac53b6",
  null
  
)

export default component.exports